module.exports = __webpack_public_path__ + "static/media/onelogin-logo.82f672fd.svg";